var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-cell"},[_vm._t("default",function(){return [_c('span',{attrs:{"title":_vm.cellData}},[_vm._v(_vm._s(_vm.cellDataParsed))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }